
import React from 'react';
import globalGetPadding from '../../utils/getPadding';
import { getFontSize } from '../../utils/commonFun';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

export const CustomErrorMessage = (_a)=> {
    var _b, _c, _d, _e, _f;
    var style = _a.style, isMobile = _a.isMobile;
    const message = _a.errorMessage;
    var wStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        fontSize: getFontSize(style?.fontSize, isMobile),
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
        textAlign: (_f = style === null || style === void 0 ? void 0 : style.textAlign) !== null && _f !== void 0 ? _f : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
    };
    return message ? <div style={wStyle}>
        {message}
    </div> : null;
}
